import React from "react";
import surajimg from "./../Sections/images/suraj.jpg";
import darshanimg from "./../Sections/images/darshan.jpg";
import neerajimg from "./../Sections/images/neeraj.jpg";
import pranavimg from "./../Sections/images/pranav-2.jpg";
import smithaimg from "./../Sections/images/smitha.jpg";

function TeamData() {
  return (
    <div id="teamdata">
      <div className="fourthheader">
        <div>FACES BEHIND</div>
        <div>THE FORMULA</div>
      </div>
      <div className="teamcontent">
        <div className="teamcontent-left">
          <div className="profile">
            <img
              src={surajimg}
              className="profile-image"
              alt="profileimg"
            ></img>
            <div className="profiletext">
              <div className="profilename">SURAJ SUVARNA</div>
              <div className="profiletitle">CHAIRMAN</div>
              <a
                className="profilelinkedin-l"
                href="https://www.linkedin.com/in/suraj-suvarna-941b344"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINKEDIN
              </a>
            </div>
          </div>
          <div className="profile">
            <img
              src={neerajimg}
              className="profile-image"
              alt="profileimg"
            ></img>
            <div className="profiletext">
              <div className="profilename">NEERAJ AMIN</div>
              <div className="profiletitle">DIRECTOR</div>
              <a
                className="profilelinkedin-l"
                href="https://www.linkedin.com/in/neeraj-amin-36155a48"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINKEDIN
              </a>
            </div>
          </div>
          <div className="profile-writeup">
            SEΠSE reimagines the intersection of Entertainment, Business,
            Talent, and Commerce as catalysts for Social Change, embodying the
            essential drivers of humanity. This organization envisions a world
            where human progress transcends mere declarations, becoming a lived
            experience. By integrating Science, Mathematics, Technology, and
            Vedic Knowledge, SEΠSE crafts a socio-economic model aimed at
            communal prosperity and sustainable abundance. Our dynamic team
            embraces innovative thinking to overcome challenges, propelling
            Project SIGNZ with a commitment to equality, equity, and a future
            where solutions transcend conventional boundaries.
          </div>
        </div>
        <div className="teamcontent-center"></div>
        <div className="teamcontent-right">
          <div id="profileright-1" className="profile">
            <img
              src={darshanimg}
              className="profile-image"
              alt="profileimg"
            ></img>
            <div className="profiletext">
              <div className="profilename">DARSHAN DWARKANATH CM</div>
              <div className="profiletitle">MANAGING DIRECTOR</div>
              <a
                className="profilelinkedin-r"
                href="https://in.linkedin.com/in/darshan-dwarkanath-cm-98971b7"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINKEDIN
              </a>
            </div>
          </div>
          <div className="profile">
            <img
              src={pranavimg}
              className="profile-image"
              alt="profileimg"
            ></img>
            <div className="profiletext">
              <div className="profilename">PRANAV BHARADWAJ</div>
              <div className="profiletitle">CHIEF TECHNICAL OFFICER</div>
              <a
                className="profilelinkedin-r"
                href="https://www.linkedin.com/in/pranav-bharadwaj-5567396b"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINKEDIN
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamData;
